export default "/images/35135809ef5e10933c0b3248ee9afc8e.png";